// extracted by mini-css-extract-plugin
export default {"card":"card_card__eU6n4","hover":"card_hover__+Kp39","interactive":"card_interactive__tKtk6","clickable":"card_clickable__MKTOG"};